<template>
  <div>
    <div class="col float-right">
      <q-btn-group outline>
        <c-update-btn 
          name="updateBtn"
          :data="param.updateBtnProps.data"
          :btnEditable="param.updateBtnProps.btnEditable"
          :flagCondition="param.updateBtnProps.flagCondition"
        />
          <!-- @back="back" -->
        <c-btn 
          v-show="tabParam.accidentStatusCd === 'ISPC000001' && !disabled && !param.isApprovePop" 
          :editable="editable" 
          label="삭제" 
          icon="delete_forever" 
          @btnClicked="remove" />
        <c-btn 
          v-show="tabParam.accidentStatusCd === 'ISPC000001' && !disabled" 
          :isSubmit="isComplete"
          :url="completeUrl"
          :param="tabParam"
          :mappingType="completeType"
          label="등록완료" 
          icon="check"
          @beforeAction="completeAccident"
          @btnCallback="completeCallback" />
      </q-btn-group>
    </div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam.sync="param"
          :tabParam="tabParam"
          :contentHeight="contentHeight"
          @transInfo="transInfo"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import { uid } from 'quasar'
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'process-accident-register',
  props: {
    param: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        count: 0,
        isApprovePop: false,
        updateBtnProps: {
          data: {
            title: '사고',
            flag: false,
          },
          flagCondition: false,
          btnEditable: false
        }
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      tabParam: {
        iimAccidentId: '',
        accidentTypeCd: '',
        plantCd: '',
        accidentNo: '',
        accidentName: '',
        accidentStatusCd: '',
        reportUserId: '',
        reportDate: '',
        accidentKindCd: '',
        accidentGradeCd: null,
        occurrenceDate: '',
        occurrenceDeptCd: '',
        occurrenceLocation: '',
        weather: '',
        emergencyMeasures: '',
        overviewAccidentSituation: '',
        occurrenceModeLargeCd: null,
        occurrenceModeSmallCd: null,
        humanDamage: '',
        directCause: '',
        indirectCause: '',
        openning: '',
        injurious: '',
        materialDamageHistory: '',
        humanDamageHistory: '',
        toxicFlag: 'N',
        accidentVictimModelList: [], // 관련 사고자
        deleteAccidentVictimModelList: [], // 사고자 삭제 모델
        accidentMaterialModelList: [], // 관련설비 및 물질
        emergencyList: [], // 비상조치계획서
        damageClassCd: null,
        woundCd: null,
      },
      completeUrl: 'transactionConfig.sop.iim.accident.process.insert.url',
      completeType: 'POST',
      isComplete: false,
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
      editable: true,
      splitter: 5,
      tab: 'processAccidentRegisterInfo',
    };
  },
  computed: {
    tabHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      numHeight = numHeight - 40
      return numHeight + 'px';
    },
    tabItems() {
      return [
        { key: uid(), name: 'processAccidentRegisterInfo', icon: 'edit', label: '사고정보', component: () => import(`${'./processAccidentRegisterInfo.vue'}`) },
        { key: uid(), name: 'processDegreeDamage', icon: 'how_to_reg', label: '피해정도', component: () => import(`${'./processDegreeDamage.vue'}`), disabled: (this.param.iimAccidentId ? false : true)},
        { key: uid(), name: 'processRelationPicture', icon: 'camera_enhance', label: '사고관련 사진', component: () => import(`${'./processRelationPicture.vue'}`), disabled: (this.param.iimAccidentId ? false : true) },
        // { key: uid(), name: 'processAccidentEquipment', icon: 'checklist', label: '사고설비 및 물질', component: () => import(`${'./processAccidentEquipment.vue'}`), disabled: (this.param.iimAccidentId ? false : true) },
        // { key: uid(), name: 'processAcidentEmergencyPlan', icon: 'manage_search', label: '관련 비상조치계획서', component: () => import(`${'./processAcidentEmergencyPlan.vue'}`), disabled: (this.param.iimAccidentId ? false : true) },
      ]
    },
    disabled() {
      return !this.tabParam.accidentStatusCd 
        || this.tabParam.accidentStatusCd === 'ISPC000005'  
        || this.tabParam.approvalStatusCd === 'ASC0000001'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.insertUrl = transactionConfig.sop.iim.accident.process.insert.url;
      this.updateUrl = transactionConfig.sop.iim.accident.process.update.url;
      this.deleteUrl = transactionConfig.sop.iim.accident.process.delete.url;
    },
    completeAccident() {
      this.completeUrl = transactionConfig.sop.iim.accident.process.complete.url;
      this.completeType = 'PUT';
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '사고등록 하시겠습니까?(저장과 함께 등록됩니다.)',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.tabParam.accidentStatusCd = 'ISPC000002'
          this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
            if (_item.expectTreatmentDate) _item.expectTreatmentDate = _item.expectTreatmentDate.join();
          })
          this.tabParam.regUserId = this.$store.getters.user.userId
          this.tabParam.chgUserId = this.$store.getters.user.userId
          
          this.isComplete = !this.isComplete;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
        if (_item.expectTreatmentDate) {
          _item.expectTreatmentDate = _item.expectTreatmentDate.split(',')
        }
      })
      if (this.tabParam.accidentStatusCd) {
        this.$emit('emitStep', {
          name: 'currentStep',
          param: this.tabParam.accidentStatusCd 
        })
      }
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.tabParam.iimAccidentId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            this.$emit('emitStep', {
              name: 'closePopup',
              param: {},
            })
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    transInfo(data) {
      this.tabParam = data;
    },
  }
};
</script>
